<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Complete Ride With Timestamps</span>
      <app-tag
        [content]="'Ride ' + config.data.ride.id"
        styleClass="light"
        sizeClass="tag-sm"
        [severityClass]="'info'"></app-tag>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="flex py-spacing-md px-spacing-xl table-bg-hover-bg border-1 border-neutral-base-primary-border radius-lg">
  <form
    [formGroup]="completeRideForm"
    class="w-full">
    <div
      class="stops-section w-full overflow-hidden"
      formArrayName="stops">
      <div class="flex justify-content-between align-items-center mb-spacing-xs">
        <h6 class="text-base mb-0">Stops</h6>
      </div>

      <p-accordion
        class="w-full"
        [multiple]="true"
        (valueChange)="accordionActiveIndexChange($event)"
        [value]="accordionActiveIndex">
        @for (stop of rideTimeline(); let stopIdx = $index; track $index) {
          <p-accordion-panel
            [value]="stopIdx"
            class="p-accordion-tab-element">
            <p-accordion-header>
              <div
                class="header-wrapper w-full"
                (click)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation()">
                <div
                  [ngClass]="{ open: accordionActiveIndex.includes(stopIdx) }"
                  class="stop w-full flex justify-content-between gap-spacing-xl align-items-start">
                  <div class="left flex flex-grow-1 gap-spacing-md align-items-start">
                    <div class="time flex flex-column align-items-center gap-spacing-default">
                      <span class="text-base font-medium text-secondary-color">{{ stop.scheduledArrivalTime }}</span>
                      <span class="text-sm font-medium text-lightest-color min-w-max">{{ config.data.rideTimezone }}</span>
                    </div>
                    <div class="badge-container relative">
                      <app-badge
                        [value]="(stopIdx + 1).toString()"
                        size="xlarge"
                        severityClass="info"></app-badge>
                      <span class="h-line"></span>
                    </div>

                    <div class="location flex flex-column gap-spacing-default border-1 border-neutral-base-primary-border border-round-lg bg-white w-full py-spacing-xs px-spacing-md">
                      <div class="place flex align-items-center gap-spacing-xs">
                        @if (stop.Type == stopPlaceType().School) {
                          <i class="icon-building-office-solid text-base text-lightest-color"></i>
                        } @else {
                          <img
                            src="assets/images/house-5 1.svg"
                            alt="" />
                        }
                        <span class="name text-base font-medium text-secondary-color">{{ stop.place }}</span>
                      </div>
                      <div class="map-location flex align-items-center gap-spacing-xs">
                        <i class="icon-map-pin-solid text-base text-link-color"></i>
                        <a class="link no-underline text-base font-normal text-link-color">
                          {{ stop.address }}
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="right flex justify-content-between align-items-center">
                    <div class="action-btns flex gap-spacing-xs align-items-center">
                      <app-button
                        [ngClass]="{ 'accordion-btn-active': accordionActiveIndex.includes(stopIdx) }"
                        (btnClick)="toggleActiveAccordionTab(stopIdx)"
                        [iconOnlyButton]="true"
                        [icon]="accordionActiveIndex.includes(stopIdx) ? 'icon-caret-up' : 'icon-caret-down'"
                        sizeClass="p-button-sm"
                        severity="primary"
                        [outlinedButton]="true"></app-button>
                    </div>
                  </div>
                </div>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <div
                class="content relative"
                [formGroupName]="stopIdx">
                <span class="h-line"></span>
                <hr class="mb-spacing-md mt-0 opacity-100 border-neutral-base-primary-border" />
                <div class="passengers mb-spacing-md py-spacing-xs px-spacing-md border-1 border-neutral-base-primary-border bg-white border-round-md">
                  <h6 class="text-base font-medium mb-spacing-default text-secondary-color">Passengers</h6>
                  <div
                    class="grid grid-nogutter gap-spacing-xs"
                    formArrayName="cargoes">
                    @for (passenger of stop.cargoes; let cargoIdx = $index; track $index) {
                      <div
                        class="passenger w-full bg-white flex justify-content-between gap-spacing-xs"
                        [formGroupName]="cargoIdx">
                        <div class="left flex align-items-center gap-spacing-xs">
                          @if (passenger.actionType.toLowerCase() == cargoActionType().PickUp.toLowerCase()) {
                            <img
                              src="assets/images/person-plus-fill 1.svg"
                              alt="" />
                          } @else if (passenger.actionType.toLowerCase() == cargoActionType().DropOff.toLowerCase()) {
                            <img
                              src="assets/images/person-dash-fill 1.svg"
                              alt="" />
                          }
                          <span class="name text-base font-medium line-height-3 text-secondary-color">
                            {{ passenger.name }}
                          </span>
                          <span class="text-sm form-border-hover-color px-spacing-default border-1 form-border-default-border line-height-2 border-round">
                            {{ passenger.type }}
                          </span>
                        </div>

                        <div class="right flex justify-content-between align-items-center">
                          @if (passenger.statusId && passenger.statusId !== RideStatusType.None) {
                            <app-tag
                              [content]="passenger.status"
                              sizeClass="tag-sm"
                              severityClass="secondary">
                            </app-tag>
                          } @else {
                            <div class="form-group flex flex-column gap-spacing-xs">
                              <div class="form-group">
                                <p-select
                                  class="block w-11rem"
                                  id="statusInput_{{ stopIdx }}_{{ cargoIdx }}"
                                  dropdownIcon="icon-caret-up-down"
                                  formControlName="rideStatusId"
                                  [options]="passengerStatusOptions().get(stopIdx + '-' + cargoIdx) || []"
                                  optionLabel="name"
                                  optionValue="id"
                                  placeholder="Passenger Status"
                                  [showClear]="false" />
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>

                @if (stopsToShowArrivalTime().has(stopIdx)) {
                  <div class="grid">
                    <div class="col-6">
                      <div class="form-group flex flex-column gap-spacing-xs">
                        <label
                          for="statusInput"
                          class="input-label label-large-medium text-primary-color">
                          Scheduled Time
                        </label>
                        <div class="form-group">
                          <span class="h-2rem border-neutral-base-primary-border flex align-items-center px-spacing-md border-round-sm form-bg-disabled-bg text-secondary-color">
                            {{ stop.scheduledArrivalTime }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group flex flex-column gap-spacing-xs">
                        <label
                          for="actualArrivalTime_{{ stopIdx }}"
                          class="input-label label-large-medium text-primary-color">
                          Actual Arrival Time
                        </label>
                        <div class="form-group">
                          <p-datepicker
                            appendTo="body"
                            formControlName="actualArrivalTime"
                            [placeholder]="'Actual Arrival Time'"
                            [iconDisplay]="'input'"
                            [showIcon]="false"
                            [timeOnly]="true"
                            hourFormat="12"
                            [inputId]="'actualArrivalTime_' + stopIdx">
                          </p-datepicker>
                          @if (stops.at(stopIdx).get("actualArrivalTime")?.hasError("invalidTime")) {
                            <small class="input-helper-text label-medium-regular text-danger-color"> Time must be later than the previous stop </small>
                          }
                          @if (stops.at(stopIdx).get("actualArrivalTime")?.hasError("beforeRideStart")) {
                            <small class="input-helper-text label-medium-regular text-danger-color"> Time cannot be before ride start time </small>
                          }
                          @if (stops.at(stopIdx).get("actualArrivalTime")?.hasError("tooLate")) {
                            <small class="input-helper-text label-medium-regular text-danger-color"> Time cannot be more than 4 hours after scheduled arrival time </small>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>
    </div>
  </form>
</div>

<div class="p-dialog-footer pt-spacing-3xl px-0">
  <div class="flex justify-content-between align-items-center">
    <div class="start">
      <app-button
        label="Delete Ride"
        (btnClick)="deleteRide()"
        [outlinedButton]="true"
        sizeClass="p-button-md"
        severity="danger"></app-button>
    </div>
    <div class="end">
      <app-button
        label="Cancel"
        (btnClick)="ref.close()"
        sizeClass="p-button-md"
        severity="secondary"></app-button>
      <app-button
        label="Complete Ride"
        [disabled]="completeRideForm.invalid"
        (btnClick)="showConfirmationDialog()"
        sizeClass="p-button-md"
        severity="primary"></app-button>
    </div>
  </div>
</div>

<!-- Second dialog -->
<p-dialog
  [showHeader]="false"
  [modal]="true"
  [(visible)]="confirmationDialogVisible"
  [style]="{ width: '400px' }">
  <div class="p-dialog-header px-0">
    <span class="background-muted-warning-bg flex p-spacing-xs border-round-md">
      <i class="icon-warning-circle-solid text-xl icon-warning-color"></i>
    </span>
    <div class="p-dialog-header-icons">
      <app-button
        (btnClick)="confirmationDialogVisible = false"
        [iconOnlyButton]="true"
        icon="icon-x"
        sizeClass="p-button-sm"
        severity="secondary"
        [textButton]="true"></app-button>
    </div>
  </div>

  <div class="flex flex-column gap-spacing-xs">
    <h5 class="mb-0 title-small-bold text-primary-color">Attention!</h5>
    <p class="mb-0 label-large-medium text-caption-color">Are you sure you want to complete this ride, this action can’t be undone?</p>
  </div>

  <div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
    <app-button
      label="Cancel"
      (btnClick)="confirmationDialogVisible = false"
      sizeClass="p-button-md"
      severity="secondary"></app-button>
    <app-button
      label="Complete Ride"
      (btnClick)="completeRide()"
      sizeClass="p-button-md"
      severity="warning"></app-button>
  </div>
</p-dialog>
<!-- End Second dialog -->
